import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const Media = makeShortcode("Media");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "template-tags"
    }}>{`Template Tags`}</h1>
    <p><strong parentName="p">{`This section describes all the template tags that can be used to author
a document template.`}</strong>{` During the `}<a parentName="p" {...{
        "href": "../document-generation-api/index.md#document-generation-process"
      }}>{`Document Generation
Process`}</a>{` , the Document
Generation API replaces the template tags in the document template with
the input data to generate the output document.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`All the tags are `}<a parentName="p" {...{
        "href": "https://docs.jsonata.org/overview.html"
      }}>{`JSONata compliant`}</a>{`.`}</p>
    <h2 {...{
      "id": "placeholder-variables"
    }}>{`Placeholder Variables`}</h2>
    <p>{`A placeholder(text tags) gets replaced by the actual input data.`}</p>
    <p><strong parentName="p">{`How to insert Placeholder Variables`}</strong></p>
    <Media slots="video" width="750" height="500" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://images-tv.adobe.com/mpcv3/5158/aa393134-7cf7-4ebb-bfd0-1ced95237d20_1615916599.854x480at800_h264.mp4#t=3"
      }}>{`https://images-tv.adobe.com/mpcv3/5158/aa393134-7cf7-4ebb-bfd0-1ced95237d20_1615916599.854x480at800_h264.mp4#t=3`}</a></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`A placeholder variable can only be applied to an input field of type
string, number or boolean. `}<br />{` Formatting applied to the placeholder
variable in the document template will be retained in the output
document.`}<br />{`
For more simplified styling and formatting for the placeholder tag from the input json data, please refer `}<a parentName="p" {...{
        "href": "../document-generation-api/stylingformattingtags.md"
      }}>{`styling and formatting`}</a>{` section:`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "accountName": "Kane Miller",
  "accountNumber": "8324e015-6400",
  "address" : {
    "street": "123 ABC Street",
    "state": "LA",
    "zip": "9XXXX"
  },
  "doctor" : "John Doe"
}
`}</code></pre>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <p>{`Placeholder variables get replaced with the actual input data.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.124999999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/5530d/placeholder_basic.webp 320w", "/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/0c8fb/placeholder_basic.webp 640w", "/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/94b1e/placeholder_basic.webp 1280w", "/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/35b21/placeholder_basic.webp 1746w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/dd4a7/placeholder_basic.png 320w", "/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/0f09e/placeholder_basic.png 640w", "/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/bbbf7/placeholder_basic.png 1280w", "/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/1805d/placeholder_basic.png 1746w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/c1fef435955a6a5b431d29cd384023c4/bbbf7/placeholder_basic.png",
            "alt": "Placeholder tags being replaced by values",
            "title": "Placeholder tags being replaced by values",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Default Value`}</strong></p>
    <p>{`A default value can be specified for the placeholder variable. In case
the specified tag is not present in the input json data, the placeholder
gets replaced with the default value.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "6.875000000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/6467314d095ac50609bd282e35d11611/5530d/placeholder_default.webp 320w", "/document-services/docs/static/6467314d095ac50609bd282e35d11611/0c8fb/placeholder_default.webp 640w", "/document-services/docs/static/6467314d095ac50609bd282e35d11611/94b1e/placeholder_default.webp 1280w", "/document-services/docs/static/6467314d095ac50609bd282e35d11611/ca7e7/placeholder_default.webp 1748w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/6467314d095ac50609bd282e35d11611/dd4a7/placeholder_default.png 320w", "/document-services/docs/static/6467314d095ac50609bd282e35d11611/0f09e/placeholder_default.png 640w", "/document-services/docs/static/6467314d095ac50609bd282e35d11611/bbbf7/placeholder_default.png 1280w", "/document-services/docs/static/6467314d095ac50609bd282e35d11611/b4f5d/placeholder_default.png 1748w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/6467314d095ac50609bd282e35d11611/bbbf7/placeholder_default.png",
            "alt": "Placeholder tags with default value set",
            "title": "Placeholder tags with default value set",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Optional`}</strong></p>
    <p>{`Setting placeholder variable as optional will replace the placeholder
with an empty string in case the specified variable is not present in
the input data.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "10.9375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/5530d/placeholder_optional.webp 320w", "/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/0c8fb/placeholder_optional.webp 640w", "/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/94b1e/placeholder_optional.webp 1280w", "/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/e03a4/placeholder_optional.webp 1744w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/dd4a7/placeholder_optional.png 320w", "/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/0f09e/placeholder_optional.png 640w", "/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/bbbf7/placeholder_optional.png 1280w", "/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/d2ccd/placeholder_optional.png 1744w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/8fb1f7338430acedbcf9b2fb3ebe6711/bbbf7/placeholder_optional.png",
            "alt": "Placeholder tags with optional image set",
            "title": "Placeholder tags with optional image set",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Prefix`}</strong></p>
    <p>{`A prefix value can be specified for the placeholder variable. Doing so will append
this value before the result of the tag.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.124999999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/5530d/placeholder_prefix.webp 320w", "/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/0c8fb/placeholder_prefix.webp 640w", "/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/94b1e/placeholder_prefix.webp 1280w", "/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/e03a4/placeholder_prefix.webp 1744w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/dd4a7/placeholder_prefix.png 320w", "/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/0f09e/placeholder_prefix.png 640w", "/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/bbbf7/placeholder_prefix.png 1280w", "/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/d2ccd/placeholder_prefix.png 1744w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/0ab56bf4e461934424a9e704414025d8/bbbf7/placeholder_prefix.png",
            "alt": "Placeholder tags with prefix image set",
            "title": "Placeholder tags with prefix image set",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "images"
    }}>{`Images`}</h2>
    <p>{`To dynamically insert an image in the document, add any image as
placeholder and edit the alt text as per the defined format:`}</p>
    <p><strong parentName="p">{`How to insert Images`}</strong></p>
    <Media slots="video" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://images-tv.adobe.com/mpcv3/5158/43cb78ad-e98d-4deb-bdca-cf32edd0df95_1615916490.854x480at800_h264.mp4#t=3"
      }}>{`https://images-tv.adobe.com/mpcv3/5158/43cb78ad-e98d-4deb-bdca-cf32edd0df95_1615916490.854x480at800_h264.mp4#t=3`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "location-path": "logo",
  "image-props": {
    "alt-text": "This is an alt-text for the image placeholder"
  }
}
`}</code></pre>
    <p>{`The properties defined in the format specifies the `}<em parentName="p">{`location-path`}</em>{` and
the `}<em parentName="p">{`alt-text`}</em>{`.`}</p>
    <p>{`The `}<em parentName="p">{`location-path`}</em>{` specifies the location of image in
the input data.`}</p>
    <p>{`Alternative text for the image can be provided using the `}<em parentName="p">{`alt-text`}</em>{`
property as defined in the format.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`The height and width of the placeholder image is retained in the
output document. `}<br />{` Supported image formats are JPEG, PNG, GIF, BMP, TIFF
and SVG.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <p>{`Image data can be provided either in the form of the base64 encoded string or in the form of publicly accessible URLs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "logo": "data:image/png;base64,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"
}
`}</code></pre>
    <p style={{
      "textAlign": "center"
    }}>OR</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "logo": "https://documentcloud.adobe.com/dc-docgen-app/assets/dc_icon.png"
}
`}</code></pre>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Only https image urls with an image size of less than 20 MB are allowed.`}</p>
    <p>{`Add the image placeholder.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "88.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9c00b14118e166868dc82001662a8b3f/5530d/image_tag_initial.webp 320w", "/document-services/docs/static/9c00b14118e166868dc82001662a8b3f/411c4/image_tag_initial.webp 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9c00b14118e166868dc82001662a8b3f/dd4a7/image_tag_initial.png 320w", "/document-services/docs/static/9c00b14118e166868dc82001662a8b3f/dface/image_tag_initial.png 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/9c00b14118e166868dc82001662a8b3f/dface/image_tag_initial.png",
            "alt": "Initial rendering of the image tag",
            "title": "Initial rendering of the image tag",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Add the alt text to the image as per the specified format.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "682px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "90.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/fd8dc14377038ad71f164b46efc7a487/5530d/image_alt_text.webp 320w", "/document-services/docs/static/fd8dc14377038ad71f164b46efc7a487/0c8fb/image_alt_text.webp 640w", "/document-services/docs/static/fd8dc14377038ad71f164b46efc7a487/94607/image_alt_text.webp 682w"],
            "sizes": "(max-width: 682px) 100vw, 682px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/fd8dc14377038ad71f164b46efc7a487/dd4a7/image_alt_text.png 320w", "/document-services/docs/static/fd8dc14377038ad71f164b46efc7a487/0f09e/image_alt_text.png 640w", "/document-services/docs/static/fd8dc14377038ad71f164b46efc7a487/0ea77/image_alt_text.png 682w"],
            "sizes": "(max-width: 682px) 100vw, 682px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/fd8dc14377038ad71f164b46efc7a487/0ea77/image_alt_text.png",
            "alt": "Adding alternative text for the image",
            "title": "Adding alternative text for the image",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`The image placeholder will be replaced by the image data in
the output document.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "676px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "69.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/b9c600d45312c08d7f41ca2d3e9107cf/5530d/image_tag_final.webp 320w", "/document-services/docs/static/b9c600d45312c08d7f41ca2d3e9107cf/0c8fb/image_tag_final.webp 640w", "/document-services/docs/static/b9c600d45312c08d7f41ca2d3e9107cf/c7990/image_tag_final.webp 676w"],
            "sizes": "(max-width: 676px) 100vw, 676px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/b9c600d45312c08d7f41ca2d3e9107cf/dd4a7/image_tag_final.png 320w", "/document-services/docs/static/b9c600d45312c08d7f41ca2d3e9107cf/0f09e/image_tag_final.png 640w", "/document-services/docs/static/b9c600d45312c08d7f41ca2d3e9107cf/ff08e/image_tag_final.png 676w"],
            "sizes": "(max-width: 676px) 100vw, 676px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/b9c600d45312c08d7f41ca2d3e9107cf/ff08e/image_tag_final.png",
            "alt": "Image placeholder replaced by the image data",
            "title": "Image placeholder replaced by the image data",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Image can also be inserted using the html `}<inlineCode parentName="p">{`<img/>`}</inlineCode>{` tag. Please refer `}<a parentName="p" {...{
        "href": "../document-generation-api/inlineimages.md"
      }}>{`Inline Images`}</a>{` to learn more about this.`}</p>
    <h2 {...{
      "id": "conditionals"
    }}>{`Conditionals`}</h2>
    <p>{`Show or hide content in the document based on the conditions.`}</p>
    <p><strong parentName="p">{`How to insert Conditional Tags`}</strong></p>
    <Media slots="video" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://images-tv.adobe.com/mpcv3/5158/671b4819-2e8c-44a1-8667-e9dfd2556133_1615916356.854x480at800_h264.mp4#t=3"
      }}>{`https://images-tv.adobe.com/mpcv3/5158/671b4819-2e8c-44a1-8667-e9dfd2556133_1615916356.854x480at800_h264.mp4#t=3`}</a></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`The condition must be wrapped inside `}<em parentName="p">{`expr()`}</em>{`. `}<br />{` Supported
conditional operators are =, !=, >=, >, <=, <.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "state": "CA"
}
`}</code></pre>
    <p><strong parentName="p">{`Conditional Sections`}</strong></p>
    <p>{`Show or hide paragraphs based on conditions.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "23.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/5530d/conditional_section.webp 320w", "/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/0c8fb/conditional_section.webp 640w", "/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/94b1e/conditional_section.webp 1280w", "/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/90d1c/conditional_section.webp 1728w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/dd4a7/conditional_section.png 320w", "/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/0f09e/conditional_section.png 640w", "/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/bbbf7/conditional_section.png 1280w", "/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/617a2/conditional_section.png 1728w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/706d5ac3d55536bd07553442aa527ee6/bbbf7/conditional_section.png",
            "alt": "Showing an paragraph based on a condition",
            "title": "Showing an paragraph based on a condition",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Conditional Phrases`}</strong></p>
    <p>{`Show or hide text inside a paragraph based on conditions.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/5530d/conditional_phrase.webp 320w", "/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/0c8fb/conditional_phrase.webp 640w", "/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/94b1e/conditional_phrase.webp 1280w", "/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/0f190/conditional_phrase.webp 1800w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/dd4a7/conditional_phrase.png 320w", "/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/0f09e/conditional_phrase.png 640w", "/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/bbbf7/conditional_phrase.png 1280w", "/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/28bdc/conditional_phrase.png 1800w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/05ef13c3b8bf6a8dbca27fc9ff0a7ce7/bbbf7/conditional_phrase.png",
            "alt": "Showing a text inside a paragraph based on a condition",
            "title": "Showing a text inside a paragraph based on a condition",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "tables"
    }}>{`Tables`}</h2>
    <h3 {...{
      "id": "insert-table-using-table-html-element"
    }}>{`Insert Table using `}<inlineCode parentName="h3">{`<table>`}</inlineCode>{` HTML Element`}</h3>
    <p>{`Add tables in the document through json data using `}<inlineCode parentName="p">{`<table>`}</inlineCode>{` tag.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Table_Data": "<table border='1' cellpadding='0' cellspacing='0' style='width:30%'><tr><th>Name</th><th>Age</th><th>Gender</th></tr><tr><td>Sheldon</td><td>29</td><td>Male</td></tr><tr><td>Leonard</td><td>30</td><td>Male</td></tr><tr><td>Howard</td><td>28</td><td>Male</td></tr><tr><td>Raj</td><td>29</td><td>Male</td></tr></table>"
}
`}</code></pre>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <p>{`Placeholder tag is replaced by a table generated using the html string provided in the input json.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "976px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "35.3125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/4be11f06ff383252d4346c7564d0b447/5530d/html_table_output.webp 320w", "/document-services/docs/static/4be11f06ff383252d4346c7564d0b447/0c8fb/html_table_output.webp 640w", "/document-services/docs/static/4be11f06ff383252d4346c7564d0b447/91b06/html_table_output.webp 976w"],
            "sizes": "(max-width: 976px) 100vw, 976px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/4be11f06ff383252d4346c7564d0b447/dd4a7/html_table_output.png 320w", "/document-services/docs/static/4be11f06ff383252d4346c7564d0b447/0f09e/html_table_output.png 640w", "/document-services/docs/static/4be11f06ff383252d4346c7564d0b447/31384/html_table_output.png 976w"],
            "sizes": "(max-width: 976px) 100vw, 976px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/4be11f06ff383252d4346c7564d0b447/31384/html_table_output.png",
            "alt": "Sample for HTML Table insertion",
            "title": "Sample for HTML Table insertion",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Placeholder Tags containing `}<inlineCode parentName="p">{`<table>`}</inlineCode>{` HTML element as value in input json data, should be placed in a separate paragraph in the input document template.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Only Inline Styling of Table elements is possible. i.e. using `}<inlineCode parentName="p">{`style`}</inlineCode>{` attribute of `}<inlineCode parentName="p">{`<table>`}</inlineCode>{`. Internal and External styling are not allowed.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "insert-table-using-placeholder-table-tag"
    }}>{`Insert Table using Placeholder Table Tag`}</h3>
    <p>{`Rows of a table can be dynamically populated by repeating over an array of objects from the input data.`}</p>
    <p><strong parentName="p">{`How to insert Tables`}</strong></p>
    <Media slots="video" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://images-tv.adobe.com/mpcv3/5158/d58772af-7a62-49fa-a098-12b11a27fb71_1615917048.854x480at800_h264.mp4#t=3"
      }}>{`https://images-tv.adobe.com/mpcv3/5158/d58772af-7a62-49fa-a098-12b11a27fb71_1615917048.854x480at800_h264.mp4#t=3`}</a></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Formatting applied to the table in the document template will be
retained in the output document.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "subscriptions": [
    {
      "name": "Adobe Document API",
      "price": "99",
      "quantity": "1",
      "amount": "99"
    },
    {
      "name": "Adobe Marketing API",
      "price": "199",
      "quantity": "2",
      "amount": "398"
    }
  ]
}
`}</code></pre>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <p>{`Create a table with requisite column headers. Add a row to the table and
place the template tags referring to the properties of the objects in
the array inside the row under the required column headings.`}</p>
    <p>{`The template tag should indicate the name of the array followed by the
property name of the objects in the array. `}<em parentName="p">{`{{subscriptions.name}}`}</em>{`
illustrates one such template tag where `}<em parentName="p">{`subscriptions`}</em>{` refer to the
array of objects while name refers to the property of one such object in
the array.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/5530d/table.webp 320w", "/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/0c8fb/table.webp 640w", "/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/94b1e/table.webp 1280w", "/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/287e6/table.webp 1820w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/dd4a7/table.png 320w", "/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/0f09e/table.png 640w", "/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/bbbf7/table.png 1280w", "/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/ebd6b/table.png 1820w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/0fd03b278ce00c8cc1f0de7cec69a596/bbbf7/table.png",
            "alt": "Table created with column headers and template tags for each subsequent rows",
            "title": "Table created with column headers and template tags for each subsequent rows",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Table rows are dynamically populated in the output document by repeating
over the specified array of objects.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "11.249999999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/5530d/table_result.webp 320w", "/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/0c8fb/table_result.webp 640w", "/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/94b1e/table_result.webp 1280w", "/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/b16a2/table_result.webp 1824w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/dd4a7/table_result.png 320w", "/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/0f09e/table_result.png 640w", "/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/bbbf7/table_result.png 1280w", "/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/955c5/table_result.png 1824w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/a65522eb00ca3be35f3cfca72e7fe7c8/bbbf7/table_result.png",
            "alt": "Table with template tags replaced with actual values in the rows",
            "title": "Table with template tags replaced with actual values in the rows",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Please visit `}<a parentName="p" {...{
        "href": "../document-generation-api/complextableconstructs.md"
      }}>{`Complex Table Constructs`}</a>{` to learn about advanced
constructs inside tables.`}</p>
    <h2 {...{
      "id": "lists"
    }}>{`Lists`}</h2>
    <p>{`Dynamically generate numbered or bullet lists by repeating over a list.`}</p>
    <p><strong parentName="p">{`How to insert Lists`}</strong></p>
    <Media slots="video" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://images-tv.adobe.com/mpcv3/5158/d58772af-7a62-49fa-a098-12b11a27fb71_1615917048.854x480at800_h264.mp4#t=3"
      }}>{`https://images-tv.adobe.com/mpcv3/5158/d58772af-7a62-49fa-a098-12b11a27fb71_1615917048.854x480at800_h264.mp4#t=3`}</a></p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "products": [
    {
      "productName": "Adobe Photoshop"
    },
    {
      "productName": "Adobe Premiere Pro"
    },
    {
      "productName": "Adobe InDesign"
    }
  ]
}
`}</code></pre>
    <p><strong parentName="p">{`Numbered Lists`}</strong></p>
    <p>{`Dynamically generate a numbered list by placing it inside a repeating
section.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/5530d/numbered_list.webp 320w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/0c8fb/numbered_list.webp 640w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/94b1e/numbered_list.webp 1280w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/0b34d/numbered_list.webp 1920w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/03ccd/numbered_list.webp 1972w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/dd4a7/numbered_list.png 320w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/0f09e/numbered_list.png 640w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/bbbf7/numbered_list.png 1280w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/ac7a9/numbered_list.png 1920w", "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/825a4/numbered_list.png 1972w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/a69cb663a2aa207aa16b5022e423a7dc/bbbf7/numbered_list.png",
            "alt": "Template tag items are replaced by numbered list",
            "title": "Template tag items are replaced by numbered list",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Bullet Lists`}</strong></p>
    <p>{`Dynamically generate a bullet list by placing it inside a repeating
section.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "22.499999999999996%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/5530d/bullet_list.webp 320w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/0c8fb/bullet_list.webp 640w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/94b1e/bullet_list.webp 1280w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/0b34d/bullet_list.webp 1920w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/36b94/bullet_list.webp 1940w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/dd4a7/bullet_list.png 320w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/0f09e/bullet_list.png 640w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/bbbf7/bullet_list.png 1280w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/ac7a9/bullet_list.png 1920w", "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/8c935/bullet_list.png 1940w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/6de6848e07252b52e516ca75c1b34b1f/bbbf7/bullet_list.png",
            "alt": "Template tag items are replaced by bullet list",
            "title": "Template tag items are replaced by bullet list",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Simple Lists`}</strong></p>
    <p>{`JSON representation of the input data in case of simple lists:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "products": ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe InDesign"]
}
`}</code></pre>
    <p>{`Dynamically generate a numbered or bullet list by placing it inside a repeating section.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "21.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/5530d/simple_lists.webp 320w", "/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/0c8fb/simple_lists.webp 640w", "/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/94b1e/simple_lists.webp 1280w", "/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/0532e/simple_lists.webp 1798w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/dd4a7/simple_lists.png 320w", "/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/0f09e/simple_lists.png 640w", "/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/bbbf7/simple_lists.png 1280w", "/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/ababd/simple_lists.png 1798w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/ecd9ec151c4a10d80680f33f784ad3a7/bbbf7/simple_lists.png",
            "alt": "Template tag items are replaced by numbered or bullet list",
            "title": "Template tag items are replaced by numbered or bullet list",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "numerical-calculations"
    }}>{`Numerical Calculations`}</h2>
    <p>{`Performing numerical calculations on the input data.`}</p>
    <p><strong parentName="p">{`How to insert Numerical Calculations`}</strong></p>
    <Media slots="video" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://images-tv.adobe.com/mpcv3/5158/e5e5e7c6-a63c-45cf-8a17-b60291068626_1615916868.854x480at800_h264.mp4#t=3"
      }}>{`https://images-tv.adobe.com/mpcv3/5158/e5e5e7c6-a63c-45cf-8a17-b60291068626_1615916868.854x480at800_h264.mp4#t=3`}</a></p>
    <p>{`All calculations supported are `}<a parentName="p" {...{
        "href": "https://docs.jsonata.org/overview.html"
      }}>{`JSONata compliant`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`All the calculations must be wrapped inside `}<em parentName="p">{`expr()`}</em>{`.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "revenue": "1000",
  "expenditure": "650",
  "subscriptions": [
    {
      "description": "Adobe Photoshop",
      "licenses": "1"
    },
    {
      "description": "Adobe Premiere Pro",
      "licenses": "2"
    },
    {
      "description": "Adobe InDesign",
      "licenses": "1"
    }
  ]
}
`}</code></pre>
    <p><strong parentName="p">{`Arithmetic`}</strong></p>
    <p>{`Performs simple arithmetic operations.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/5530d/arithmetic.webp 320w", "/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/0c8fb/arithmetic.webp 640w", "/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/94b1e/arithmetic.webp 1280w", "/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/643a2/arithmetic.webp 1756w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/dd4a7/arithmetic.png 320w", "/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/0f09e/arithmetic.png 640w", "/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/bbbf7/arithmetic.png 1280w", "/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/0aea6/arithmetic.png 1756w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/89dc39ad8624f6e9a8a6652ae9ed7d12/bbbf7/arithmetic.png",
            "alt": "Performing simple arithmetic to show revenue-expenditure",
            "title": "Performing simple arithmetic to show revenue-expenditure",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Supported arithmetic operations are +, -, `}{`*`}{`, /, % . `}<br />{` An
arithmetic numerical calculation can only be applied to input fields
that corresponds to a number.`}</p>
    <p><strong parentName="p">{`Aggregation`}</strong></p>
    <p>{`Performs aggregations on a list of elements.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "7.187500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/5530d/aggregation.webp 320w", "/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/0c8fb/aggregation.webp 640w", "/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/94b1e/aggregation.webp 1280w", "/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/ff2d6/aggregation.webp 1754w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/dd4a7/aggregation.png 320w", "/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/0f09e/aggregation.png 640w", "/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/bbbf7/aggregation.png 1280w", "/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/f2be5/aggregation.png 1754w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/9d6efc0935c7c3f4fdffa4ae91fd4da6/bbbf7/aggregation.png",
            "alt": "Performing simple arithmetic to show aggregation",
            "title": "Performing simple arithmetic to show aggregation",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Here is the list of `}<a parentName="p" {...{
        "href": "https://docs.jsonata.org/aggregation-functions"
      }}>{`supported aggregation functions`}</a>{` `}<br />{` An
aggregate numerical calculation can only be applied to a list of
numbers.`}</p>
    <h2 {...{
      "id": "adobe-sign"
    }}>{`Adobe Sign`}</h2>
    <p>{`Adobe Sign text tags can be placed anywhere within the contents of the document template.`}</p>
    <p>{`These tags are converted into Adobe Sign form fields when the final document is sent for a signature using Adobe Sign.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Please visit `}<a parentName="p" {...{
        "href": "https://helpx.adobe.com/in/sign/using/text-tag.html"
      }}>{`Adobe Sign Text Tag Guide`}</a>{` to learn about different Adobe Sign text tags.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      